type Types =
  | 'object'
  | 'string'
  | 'number'
  | 'boolean'
  | 'undefined'
  | 'symbol'
  | 'function'
  | 'bigint'

export const isTypedKeyInObject = <T extends object>(
  object: T,
  key: string,
  expectedType: Types,
) => {
  const result = key in object
  return result && typeof object[key as keyof T] === expectedType
}
